import { StyledCol, StyledRow } from 'src/layouts/styles';
import { ReportDetails } from '~/features';
import { PageLayout } from '~/layouts';

const ReportDetailsRoute = () => {
    return (
        <PageLayout>
            <StyledRow>
                <StyledCol col={12}>
                    <ReportDetails />
                </StyledCol>
            </StyledRow>
        </PageLayout>
    );
};
export default ReportDetailsRoute;
